import { Model } from 'modules/core/lib/mobx-rest'

interface ICompensation {
  errors: Array<{ employee_id: number; error: string | undefined }>
  successes: Array<{ employee_id: number; error: string | undefined }>
  message: string
}

class Compensation extends Model<ICompensation> {
  constructor(attr: ICompensation) {
    super(attr)
  }

  static urlRoot() {
    return '/attendance/compensation'
  }
}

export default Compensation
